import React from 'react';
import { connect } from 'react-redux';
import { reduceById } from 'Jsx/Catalog/utils';

import T from 'aegisv2/Text';

import Dropdown from './components/Dropdown';
import StyledSelect from './components/StyledSelect';

import { selectOrderBy } from './redux/actions';

import { getSelectedLanguages } from '../FiltersV2/redux/selectors';
import { setSelectedLanguages } from '../FiltersV2/redux/actions';

const OrderByV2 = ({
  items,
  itemSelected,
  languagesArray,
  selectedLanguages,
  scrollTop,
  withOrderByLabel,
  ...rest
}) => {
  const languages = languagesArray.map(el => ({
    ...el,
    value: el.slug,
    label: el.name,
  }));

  const selected = Object.keys(selectedLanguages)
    .map(key => selectedLanguages[key])
    .map(el => ({ ...el, value: el.slug, label: el.name }));

  const onChange = item => {
    if (scrollTop) scrollTop();
    rest.selectOrderBy(item);
  };

  const onSelectLanguage = values => {
    rest.setSelectedLanguages(
      values
        .map(el => ({
          ...el,
          id: el.value === 'es' ? 1 : 2,
          slug: el.value,
          name: el.label,
        }))
        .reduce(reduceById, {}),
    );
  };

  const onSelectOrderOption = option => {
    if (scrollTop) scrollTop();
    rest.selectOrderBy(option);
  };

  return (
    <div
      className="flex items-center w-full mt-0"
      css={`
        @media (min-width: 1140px) {
          margin-top: 8;
        }
      `}
    >
      <Dropdown
        label="Idiomas"
        options={languages}
        onSelected={onSelectLanguage}
        selected={selected}
        className="mr-24"
        css={`
          display: none;
          @media (min-width: 1140px) {
            display: block;
          }
        `}
      />
      <div
        className="flex items-center"
        css={`
          display: none;
          @media (min-width: 1140px) {
            display: block;
          }
        `}
      >
        <Dropdown
          label="Ordenar por"
          options={items}
          onSelected={onSelectOrderOption}
          selected={[itemSelected]}
          singleSelect
        />
      </div>
      <div
        className="w-full"
        css={`
          display: block;
          @media (min-width: 1140px) {
            display: none;
          }
        `}
      >
        <StyledSelect
          options={items}
          value={itemSelected.value}
          clearable={false}
          deleteRemoves={false}
          searchable={false}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

OrderByV2.defaultProps = {
  scrollTop: null,
};

const mapStateToProps = state => ({
  items: state.orderBy.items,
  itemSelected: state.orderBy.itemSelected,
  languagesArray: state.filters.languagesArray,
  selectedLanguages: getSelectedLanguages(state),
});

export default connect(mapStateToProps, {
  selectOrderBy,
  setSelectedLanguages,
})(OrderByV2);
